import React, { FC, useState, useContext } from 'react';

const ToggleGroupContext = React.createContext(null);
const ToggleGroupProvider: FC = ({ children }) => {
  const [selected, setSelected] = useState(null);

  const value: any = {
    selected,
    setSelected,
  };
  return <ToggleGroupContext.Provider value={value}>{children}</ToggleGroupContext.Provider>;
};

const useToggleGroup = () => {
  const ctx = useContext(ToggleGroupContext);
  if (ctx === undefined) {
    return;
  }
  return ctx;
};

export { ToggleGroupProvider, useToggleGroup };
